import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';
const moment = require('moment'); 

const ListarContratos = () => {
  const { id } = useParams();
  const [contratos, setContratos] = useState([]);
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      const res = await axios.get(`/api/contratos/listbyinstructor/${id}`);

      if (res.data.ok) {
        const dataConItem = res.data.contratos.map((contrato, index) => ({
          item: index + 1,
          _id: contrato._id,
          numeroContrato: contrato.contrato,
          // Formatear fechas (DD/MM/YYYY) y ajustar zona horaria si es necesario
          fechaInicio: contrato.fechaInicio
            ? moment.utc(contrato.fechaInicio).add(5, 'hours').format('DD/MM/YYYY')
            : null,

          fechaFin: contrato.fechaFin
            ? moment.utc(contrato.fechaFin).add(5, 'hours').format('DD/MM/YYYY')
            : null,
          valorContrato: `$${contrato.valorContrato?.toLocaleString()}`,
          estado: contrato.estado,
          entidadContratante: contrato.regional?.nombreRegional || '-',  // 🔍 Solo el nombre
          centroFormacion: contrato.centroFormacion?.nombreCentro || '-', // 🔍 Solo el nombre
          nombreInstructor: contrato.instructorNombreCompleto || '-',
          documentoInstructor: contrato.instructor?.documentoInstructor || '-',
          funciones: (
            <div className="d-flex gap-2">
              <button className="btn btn-primary"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => navigate("/instructor/agendasviaticos")}
                title="Agendas de Viaje">
                <i className="fa-solid fa-plane"></i>
              </button>

              <button
                className="btn btn-primary"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => navigate(`/instructor/informecontractual/listar/${contrato._id}`)}
                title="Listar Informes Contractuales"
              >
                <i className="fa-solid fa-list-check"></i>
              </button>


              <button className="btn btn-primary"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => navigate(`/instructor/informecontractual/${contrato._id}`)}
                title="Informe Contractual">
                <i className="fa-solid fa-clipboard-check"></i>
              </button>

              <button className="btn btn-secondary"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => navigate(`/instructor/obligaciones/${contrato._id}`)}
                title="Obligaciones Contractuales">
                <i className="fa-solid fa-clipboard-list"></i>
              </button>

              <button className="btn btn-warning"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => navigate(`/instructor/registrarcontratos/editar/${contrato._id}`, {
                  state: { contrato }
                })}
                title="Editar Contrato">
                <i className="fa-solid fa-edit"></i>
              </button>

              <button className="btn btn-danger"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => deleteContrato(contrato._id)}
                title="Eliminar Contrato">
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ),
        }));

        setContratos(dataConItem);
      }
    } catch (error) {
      console.error('Error al obtener contratos:', error);
    }
    // eslint-disable-next-line 
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const deleteContrato = async (idContrato) => {
    try {
      const result = await Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        await axios.delete(`/api/contratos/delete/${idContrato}`);
        setContratos(prev => prev.filter(contrato => contrato._id !== idContrato));

        Swal.fire({
          icon: 'success',
          title: 'Contrato eliminado correctamente',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error('Error al eliminar el contrato:', error);
      Swal.fire(
        'Error',
        error.response?.data?.message || 'No se pudo eliminar el contrato',
        'error'
      );
      getData(); // Recuperar en caso de error
    }
  };

  const columns = [
    { Header: 'Item', accessor: 'item' },
    { Header: 'N° Contrato', accessor: 'numeroContrato' },
    { Header: 'Inicio', accessor: 'fechaInicio' },
    { Header: 'Fin', accessor: 'fechaFin' },
    { Header: 'Valor ($)', accessor: 'valorContrato' },
    { Header: 'Estado', accessor: 'estado' },
    { Header: 'Entidad', accessor: 'entidadContratante' },
    { Header: 'Centro de Formación', accessor: 'centroFormacion' },
    { Header: 'Opciones', accessor: 'funciones' },
  ];

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
       <div className="d-flex align-items-center mb-3">
        <button
          style={{ marginTop: '24px', marginLeft: '32px' }}
          className="btn btn-outline-dark rounded-pill shadow-sm px-3 d-flex align-items-center gap-2 me-3"
          onClick={() => navigate(-1)}
          title="Regresar"
        >
          <i class="fa-solid fa-arrow-rotate-left"></i>
          <span>Volver</span>
        </button>

        <h1 className="text-center flex-grow-1 m-0">Contratos del Instructor</h1>
      </div>

      <DataTable columns={columns} data={contratos} />
    </div>
  );
};

export default ListarContratos;
